import {
  assessments as AssessmentsServices,
  homeworks as HomeworksServices,
} from '@coligo-org/fe-common/services';
import { ErrorsActions } from '../error';
import logger from '../../../common/services/logService';
import { coursesTypes } from '../../reducers/types';

export const CancelAssessmentStart = () => ({
  type: coursesTypes.CANCEL_ASSESSMENT_START,
});

export const CancelAssessmentEnd = () => ({
  type: coursesTypes.CANCEL_ASSESSMENT_END,
});

const cancelAssessment = (isHomework, assessmentId) =>
  isHomework
    ? HomeworksServices.cancelHomework({ homeworkId: assessmentId })
    : AssessmentsServices.cancelAssessment({ assessmentId });

export default (
    { assessmentId, callback, isHomework } = { isHomework: false },
  ) =>
  async dispatch => {
    try {
      dispatch(CancelAssessmentStart());
      await cancelAssessment(isHomework, assessmentId);
      if (callback) callback();
    } catch (error) {
      logger.log(error);
      if (error.response) {
        dispatch(ErrorsActions.addError(error.response.data.message));
      }
    } finally {
      dispatch(CancelAssessmentEnd());
    }
  };
